import { toast } from "react-hot-toast"

import { setLoading, setUser } from "../../slices/profileSlice"
import { apiConnector } from "../apiconnector"
import { profileEndpoints } from "../apis"
import { logout } from "./authAPI"

const { GET_USER_DETAILS_API, 
  GET_USER_ENROLLED_COURSES_API,
  GET_INSTRUCTOR_DATA_API  
} = profileEndpoints

export function getUserDetails(token, navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    dispatch(setLoading(true))
    try {
      const response = await apiConnector("GET", GET_USER_DETAILS_API, null, {
        Authorization: `Bearer ${token}`,
      })
      console.log("GET_USER_DETAILS API RESPONSE............", response)

      if (!response.data.success) {
        throw new Error(response.data.message)
      }
      const userImage = response.data.data.image
        ? response.data.data.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.data.firstName} ${response.data.data.lastName}`
      dispatch(setUser({ ...response.data.data, image: userImage }))
    } catch (error) {
      dispatch(logout(navigate))
      console.log("GET_USER_DETAILS API ERROR............", error)
      toast.error("Could Not Get User Details")
    }
    toast.dismiss(toastId)
    dispatch(setLoading(false))
  }
}

export async function getUserEnrolledCourses(token) {
  const toastId = toast.loading("Loading...")
  let result = []
  try {
    console.log("BEFORE Calling BACKEND API FOR ENROLLED COURSES");
    const response = await apiConnector(
      "GET",
      GET_USER_ENROLLED_COURSES_API,
      null,
      {
        Authorization: `Bearer ${token}`,
      }
    )
    console.log("AFTER Calling BACKEND API FOR ENROLLED COURSES");
    // console.log(
    //   "GET_USER_ENROLLED_COURSES_API API RESPONSE............",
    //   response
    // )

    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    result = response.data.data
  } catch (error) {
    console.log("GET_USER_ENROLLED_COURSES_API API ERROR............", error)
    toast.error("Could Not Get Enrolled Courses")
  }
  toast.dismiss(toastId)
  return result
}

export async function getInstructorData(token) {
  const toastId = toast.loading("Loading...")
  let result = []
  try {

    const response = await apiConnector("GET", GET_INSTRUCTOR_DATA_API, null,
    {
      Authorization: `Bearer ${token}`
    } )
    console.log("GET_INSTRUCTOR_DATA_API response....", response)
    result= response?.data?.courses
  } catch (error) {
    console.log("GET_INSTRUCTOR_DATA_API API ERROR............", error)
    toast.error("Could Not Get Instructor Data")
  }
  toast.dismiss(toastId)
  return result
}

export async function removeEnrolledCourse(courseId, token) {
  const toastId = toast.loading("Removing...")
  let result = false
  try {
    const response = await apiConnector(
      "DELETE",
      profileEndpoints.REMOVE_ENROLLED_COURSE_API,
      { courseId },
      {
        Authorization: `Bearer ${token}`,
      }
    )
    console.log("REMOVE_ENROLLED_COURSE_API RESPONSE............", response)

    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    toast.success("Course removed successfully")
    result = true
  } catch (error) {
    console.log("REMOVE_ENROLLED_COURSE_API ERROR............", error)
    toast.error("Could Not Remove Course")
  }
  toast.dismiss(toastId)
  return result
}

export async function getAdminDashboardData(token) {
  let result = null
  try {
    const response = await apiConnector(
      "GET",
      profileEndpoints.GET_ADMIN_DASHBOARD_DATA_API,
      null,
      {
        Authorization: `Bearer ${token}`,
      }
    )
    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    result = response.data.data
  } catch (error) {
    console.log("GET_ADMIN_DASHBOARD_DATA_API ERROR............", error)
    toast.error("Could Not Get Admin Dashboard Data")
  }
  return result
}

export async function approveInstructorData(instructorId, token) {
  let result = false
  const toastId = toast.loading("Updating...")
  try {
    const response = await apiConnector(
      "PUT",
      profileEndpoints.APPROVE_INSTRUCTOR_API,
      { instructorId },
      {
        Authorization: `Bearer ${token}`,
      }
    )
    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    toast.success("Instructor Status Updated")
    result = true
  } catch (error) {
    console.log("APPROVE_INSTRUCTOR_API ERROR............", error)
    toast.error("Could Not Update Instructor Status")
  }
  toast.dismiss(toastId)
  return result
}